<template>
  <Paper>
    <h2 class="text-2xl text-cal-009588 mb-4">Training videos</h2>
    <div class="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4 lg:gap-8">
      <div v-for="video in videos" :key="video.id" @click="selectVideo(video)" class="shadow-sm border border-gray-50 hover:ring ring-cal-blue ring-offset-2 cursor-pointer bg-cal-F4F2F2 flex flex-col group">
        <img :src="video.acf.gated_content_thumbnail" />
        <div class="p-4 flex-grow">
          <div class="text-cal-light-blue group-hover:text-cal-blue text-xl font-bold mb-2">{{video.title.rendered}}</div>
          <div v-html="video.excerpt.rendered"></div>
        </div>
      </div>
    </div>
    <vue-modal v-if="showVideo" @close="selectedVideo = null">
      <div slot="footer"></div>
      <div slot="header">
        <h3>{{selectedVideo.title.rendered}}</h3>
      </div>
      <div slot="body">
        <div class="relative pt-[56.9%]">
          <iframe
              :src="selectedVideo.acf.gated_content_video"
              allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
              allowfullscreen="true"
              class="absolute inset-0 w-full h-full"
          ></iframe>
        </div>
      </div>
    </vue-modal>
  </Paper>
</template>
<script>
import Paper from '../Layout/Paper.vue'
import VueModal from "../Shared/VueModal";
export default {
  components: {VueModal, Paper },
  data() {
    return {
      videos: [],
      selectedVideo: null,
      showVideo: false,
    }
  },
  created() {
    this.$http.get('https://www.constructalead.com/wp-json/wp/v2/training-videos')
        .then(response => {
          this.videos = response.data
        })
  },
  methods: {
    selectVideo(video) {
      this.selectedVideo = video;
    }
  },
  watch: {
    'selectedVideo': function (value) {
      this.showVideo = value !== null;
    }
  }
}
</script>
